import qs from 'qs';
import { createAction } from '@reduxjs/toolkit';
import { takeLatest, put } from 'redux-saga/effects';

import http from 'app/services/httpService';
import { callWrapperSaga } from 'app/services/sagaService';
import apiEndpoints, { buildApiRoute } from 'routes/apiEndpoints';

import {
  getPartnerApiLogsInit,
  getPartnerApiLogsSuccess,
  getPartnerApiLogsFailure,
  getPartnerApiLogInit,
  getPartnerApiLogSuccess,
  getPartnerApiLogFailure,
} from './partnerApiLogSlice';

const getPartnerApiLogs = createAction('partnerApiLogs/list');
const getPartnerApiLog = createAction('partnerApiLogs/get');

function* getPartnerApiLogsSaga({ payload }) {
  yield put(getPartnerApiLogsInit());

  try {
    const { page_number, page_size, ...rest } = payload || {};
    const query = {
      ...rest,
      PageNumber: page_number,
      PageSize: page_size,
    };
    const endpoint = `${apiEndpoints.getPartnerApiLogs}?${qs.stringify(query)}`;
    const response = yield callWrapperSaga(() => http.get(endpoint));

    yield put(getPartnerApiLogsSuccess(response.data));
  } catch (error) {
    yield put(getPartnerApiLogsFailure(error));
  }
}

function* getPartnerApiLogSaga({ payload: id }) {
  try {
    yield put(getPartnerApiLogInit());
    let endpoint = buildApiRoute(apiEndpoints.getPartnerApiLog, id);
    let response = yield callWrapperSaga(() => http.get(endpoint));

    yield put(getPartnerApiLogSuccess(response.data));
  } catch (error) {
    yield put(getPartnerApiLogFailure(error));
  }
}

function* partnerApiLogSaga() {
  yield takeLatest(getPartnerApiLogs, getPartnerApiLogsSaga);
  yield takeLatest(getPartnerApiLog, getPartnerApiLogSaga);
}

export default partnerApiLogSaga;

export { getPartnerApiLogs, getPartnerApiLog };
